import {axios} from '@http_client';

class Captcha {
    constructor() {
        this.token = null;
        this.image = null;
    }

    /**
     * @param {Object} entity
     *
     * @return {Captcha}
     * */
    static make(entity) {
        const captcha = new Captcha();

        captcha.image = entity.image ?? null;
        captcha.token = entity.token ?? null;

        return captcha;
    }
}


/**
 * @param {String} token
 *
 * @return Promise <Captcha>
 * */
function getCaptcha(token) {
    const path = 'v1/users/captcha/' + token;

    return new Promise((resolve, reject) => {
        axios.get(path).then(response => {
            resolve(Captcha.make(response.data));
        }).catch(error => {
            reject(error);
        });
    })
}

export {
    getCaptcha
}